import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl} from "@angular/forms";

import {TranslateService} from "@ngx-translate/core";

import {BaseComponent} from "@shared/components/base-component";

import {FilterType, HandoverNotificationsService} from "@handover/routes/main-route/services/handover-notifications.service";

@Component({
  selector: 'handovermod-vehicles-filter',
  templateUrl: './vehicles-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehiclesFilterComponent extends BaseComponent implements OnInit, OnDestroy {

  readonly FilterType = FilterType;

  readonly statues: string[] = [];
  searchCtrl = new FormControl<string>('');

  form = this.formBuilder.group({
    search: this.searchCtrl,
  });

  private currentFilter = FilterType.All;

  constructor(
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private handoverNotificationsService: HandoverNotificationsService
  ) {
    super();
    this.setTranslations();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

  ngOnInit(): void {
    this.addToUnsubscribe(
      this.form.controls.search.valueChanges.subscribe(newValue => {
        this.handoverNotificationsService.filterTextChangeSubject$.next(newValue?.toLowerCase() ?? '');
      }));
  }

  isFilterSelected(filter: number): boolean {
    return this.currentFilter === filter;
  }

  onFilterSelected(filter: number) {
    this.currentFilter = filter;
    this.handoverNotificationsService.filterStatusChangeSubject$.next(this.currentFilter);
  }

  private setTranslations() {
    this.translateService.get([
      'labels.all',
      'handover.filter-available',
      'handover.filter-given'])
      .subscribe(t => {
        Object.entries<string>(t).forEach((x) => this.statues.push(x[1]));
      });
  }

  onClean() {
    this.form.controls.search.setValue('');
    this.onFilterSelected(FilterType.All);
  }
}
